import React from 'react';
import PropTypes from 'prop-types';
import {BASE_TEXT, WEIGHT} from '../../../../shared/style/typography';
import glamorous from 'glamorous';
import {PHONE_LANDSCAPE} from '../../../../shared/style/breakpoints';
import PrivatePublicIndicator from '../../../../shared/library/private-public-indicator';

const Container = glamorous.div({
  ...BASE_TEXT,
  fontSize: 18,
  fontWeight: WEIGHT.BOLD,
  [PHONE_LANDSCAPE]: {
    fontSize: 15
  }
});

const Title = ({copy, isPrivate = false}) => {
  return (
    <Container>
      <span>
        {copy}
        {isPrivate && (
          <PrivatePublicIndicator typeIndicator={'BlueRoundSmall'} displayInline={true} />
        )}
      </span>
    </Container>
  );
};

Title.propTypes = {
  copy: PropTypes.string,
  isPrivate: PropTypes.bool
};

export default Title;
